import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class ComponentEventService {
    private _radioButtonDI: string = ''; // default unset so no preselection
    public isImporting = false;
    private cb1_DI_EI_Source = new BehaviorSubject<boolean>(true);
    enabledComboBox1_DI_EquipInfoObservable = this.cb1_DI_EI_Source.asObservable();
    public allowableStressTempS = new BehaviorSubject<number>(0);
    public SMYS_KSI = new BehaviorSubject<number>(0);
    public isHelpDialogModeActive = new BehaviorSubject<boolean>(false);

    public compMAWPintEquip = new BehaviorSubject<number>(-1);
    compMAWPintEquip$ = this.compMAWPintEquip.asObservable();
    public compmaterialstress = new BehaviorSubject<number>(-1);
    public compMAEPintEquip = new BehaviorSubject<number>(-1);
    public typeASelected = new BehaviorSubject<number>(0);
    public unitSelected$ = new BehaviorSubject<number>(0);
    public typedamageSelected$ = new BehaviorSubject<string>("");
    hideHeaderFooter$ = new BehaviorSubject<boolean>(false);

    public typearadioSelected$ = new BehaviorSubject<number>(0);

    public typeAinput1val$ = new BehaviorSubject<number>(0);

    public typeAinput2val$ = new BehaviorSubject<number>(0);

    public typeAUnitytypeval$ = new BehaviorSubject<number>(0);

    public typeAresultfrmjsnval$ = new BehaviorSubject<number>(0);


    private reevaluButtonEnabledSubject = new BehaviorSubject<boolean>(false);
    reevaluButtonEnabled = this.reevaluButtonEnabledSubject.asObservable();

    setReevalButtonEnabled(enabled: boolean) {
        this.reevaluButtonEnabledSubject.next(enabled);
    }

    public updatetypeAradioselected(value: number): void {
        this.typearadioSelected$.next(value);
    }

    public get typearadioselectedValue() {
        return this.typearadioSelected$.value;
    }


    public updatetypeAinput1val(value: number): void {
        this.typeAinput1val$.next(value);
    }

    public get typeatypeAinput1val() {
        return this.typeAinput1val$.value;
    }

    
    public updatetypeAUnitTypeval(value: number): void {
        this.typeAUnitytypeval$.next(value);
    }

    public get typeAUnitTypeval() {
        return this.typeAUnitytypeval$.value;
    }


//
    public updatetypeAresultjsnval(value: number): void {
    this.typeAresultfrmjsnval$.next(value);
    }

    public get typeAresultjsnval() {
    return this.typeAresultfrmjsnval$.value;
    }

  //   
    public updatetypeAinput2val(value: number): void {
        this.typeAinput2val$.next(value);
    }

    public get typeatypeAinput2val() {
        return this.typeAinput2val$.value;
    }


    enableComboBox1_DI_EquipInfo(enable: boolean) {
        this.cb1_DI_EI_Source.next(enable)
    }

    public updateAllowableStressTempS(value: number): void {
        this.allowableStressTempS.next(value);
    }
    public SetValueForKSI(value: number): void {
        this.SMYS_KSI.next(value);
    }

    public get allowableStressTempSValue() {
        return this.allowableStressTempS.value;
    }

    public updateHelpDialogModeActive(value: boolean): void {
        this.isHelpDialogModeActive.next(value);
    }

    public get isHelpDialogModeActiveValue() {
        return this.isHelpDialogModeActive.value;
    }

    public updateCompMAWPintEquip(value: number): void {
        this.compMAWPintEquip.next(value);
    }

    public get compMAWPintEquipValue() {
        return this.compMAWPintEquip.value;
    }

    public updateMaterialStress(value: number): void {
        this.compmaterialstress.next(value);
    }
    public get updateMaterialStressValue() {
        return this.compmaterialstress.value;
    }
    
    public updateCompMAEPintEquip(value: number): void {
        this.compMAEPintEquip.next(value);
    }

    public get compMAEPintEquipValue() {
        return this.compMAEPintEquip.value;
    }

    public updateTypeASelectedValue(value: number): void {
        this.typeASelected.next(value);
    }

    public get hideHeaderFooterValue() {
        return this.hideHeaderFooter$.value;
    }

    public updateHideHeaderFooterValue(value: boolean): void {
        this.hideHeaderFooter$.next(value);
    }

    public get unitSelectedValue() {
        return this.unitSelected$.value;
    }

    public updateUnitSelectedValue(value: number): void {
        this.unitSelected$.next(value);
    }
 
    private typeDamageSelectedSubject = new BehaviorSubject<string>('');
    typeDamageSelected$ = this.typeDamageSelectedSubject.asObservable();

    updateTypeDamageValue(value: string): void {
            this.typeDamageSelectedSubject.next(value);
    }

    get typeDamageSelectedValue(): string {
        return this.typeDamageSelectedSubject.value;
    }

    set radioButtonDI(value: string) {
        this._radioButtonDI = value;
    }

    get radioButtonDI(): string {
        return this._radioButtonDI;
    }
}